export const dbsKeys = {
  provinces: "dbs.provinces.v1",
  deals: "dbs.deals.v1",
  businesses: "dbs.businesses.v1",
  bookings: "dbs.bookings.v1",
  users: "dbs.users.v1",
  favorites: "dbs.favorites.v1",
  alerts: "dbs.alerts.v1",
  session: "dbs.session.v1",
  payments: "dbs.payments.v1",
  subscriptions: "dbs.subscriptions.v1",
};
